import type { JSONSchema7 } from 'json-schema';

export type IpRangePickerUiOptions = {
  /** Map of region names to the address pool from which a block is allocated. */
  regionBaseMap?: Record<string, string>;
  /** Optional form field whose value selects a key in regionBaseMap. */
  regionField?: string;
  /** Form field whose value is sent as the allocation description. */
  applicationField?: string;
  /** Region selected initially when regionField is not supplied. */
  defaultRegion?: string;
  /** Optional title and description sent to the allocation API. */
  title?: string;
  desc?: string;
  /** T-shirt size choices and their IPv4 prefix lengths. */
  sizes?: Array<{ size: string; mask: string }>;
};

export const IpRangePickerSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      regionBaseMap: {
        type: 'object',
        title: 'Region address pools',
        description:
          'Map region names to their address pools. For example, westeurope: 10.128.32.0/19.',
        additionalProperties: { type: 'string' },
      },
      regionField: {
        type: 'string',
        title: 'Region form field',
        description:
          'Optional field containing a region key from Region address pools. When set, the region selector is hidden.',
      },
      applicationField: {
        type: 'string',
        title: 'Application form field',
        description:
          'Optional field whose value is sent to the allocator as the description.',
      },
      defaultRegion: {
        type: 'string',
        title: 'Default region',
      },
      title: { type: 'string', title: 'Allocation title' },
      desc: { type: 'string', title: 'Allocation description' },
      sizes: {
        type: 'array',
        title: 'T-shirt sizes and masks',
        description:
          'Configure the size labels and IPv4 prefix lengths shown in the picker.',
        items: {
          type: 'object',
          required: ['size', 'mask'],
          properties: {
            size: { type: 'string', title: 'Size label' },
            mask: { type: 'string', title: 'Mask prefix length' },
          },
        },
      },
    },
  } as JSONSchema7,
  returnValue: {
    title: 'Allocated IP range',
    type: 'string',
    description: 'CIDR range allocated by the IP address management service',
  } as JSONSchema7,
};
